import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-dropdown-select";
import FormControl from "@mui/joy/FormControl";
import Radio from "@mui/joy/Radio";
import RadioGroup from "@mui/joy/RadioGroup";
import axiosInstance from "../services/axiosInstance";
import { Resolution, Margin } from "react-to-pdf";
import PreorderSheet from "./preorderSheet.jsx";
import OrderPopUp from "../Popup/orderPopup.jsx";
import { OrderStatusEnum } from "../enums/OrderEnum";
import { decrypt } from "../utils/cryptoUtils.js";
import DeleteOrderPopup from "../Popup/deleteOrderPopup.jsx";

const formatDueDeliveryDate = (dueDeliveryDate) => {
  if (!dueDeliveryDate) return "";

  const date = new Date(dueDeliveryDate);

  // Extract day, month, hours, and minutes
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  // Format as dd.MM | HH:mm
  return `${day}.${month} | ${hours}:${minutes}`;
};

const AddDetailsForDelivery = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [pdfData, setPdfData] = useState({
    patientName: "",
    dueDate: "",
    deliveryDate: "",
  });
  const option = {
    method: "open",
    resolution: Resolution.NORMAL,
    page: {
      margin: Margin.SMALL,
      format: "A6",
      orientation: "landscape",
    },
    canvas: { mimeType: "image/png", qualityRatio: 1 },
    overrides: { canvas: { useCORS: true } },
  };

  const getTargetElement = () => document.getElementById("pre-order-sheet");
  const navigate = useNavigate();

  const [dentistList, setDentishList] = useState([]);
  const [orderTypeList, setorderTypeList] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [errors, setErrors] = useState({});
  const [openPopup, setOpenPopup] = useState(false);
  const location = useLocation();

  const HandleDeletePopUp = () => setOpenPopup(false);

  const [orderData, setOrderData] = useState({
    orderId: 0,
    dentistId: 0,
    patientName: "",
    orderTypeId: 0,
    orderStatusId: OrderStatusEnum.PickedUpAtDentist,
    isActive: true,
    createdByUserId: 1,
    lastUpdatedByUserId: 1,
  });

  useEffect(() => {
    getDetails();

    const encryptedId = getQueryParams();
    if (encryptedId) {
      const decryptedId = decrypt(encryptedId);
      //console.log(decryptedId);
      const fetchOrderDetails = async () => {
        try {
          const response = await axiosInstance.post(
            "/api/Order/getOrderDetails",
            {
              orderId: parseInt(decryptedId),
            }
          );

          const mappedOrder = {
            orderId: response?.orderId,
            dentistId: response?.dentistId,
            patientName: response?.patientName,
            orderTypeId: response?.orderTypeId,
            orderStatusId: response?.orderStatusId,
            isActive: response.isActive,
            createdByUserId: response.createdByUserId ?? 0,
            lastUpdatedByUserId: response.lastUpdatedByUserId ?? 0,
          };

          setOrderData(mappedOrder);
        } catch (error) {
          console.error("Fehler beim Abrufen der Auftragsdaten:", error);
        }
      };

      if (decryptedId) {
        fetchOrderDetails();
      }
    } else {
      console.log("No encrypted ID found");
    }
  }, []);

  const getQueryParams = () => {
    const queryParams = new URLSearchParams(location.search);
    const orderId = queryParams.get("orderId");
    return orderId;
  };

  const getDetails = async () => {
    try {
      const OrderInfo = await axiosInstance.get(
        "/api/Order/getDentailOrderInfo/true"
      );

      setorderTypeList(OrderInfo.orderType);
      setDentishList(OrderInfo.dentist);
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  const cardStyle = {
    boxShadow: "0px 0px 8px rgba(44, 99, 152, 0.12)",
  };

  const createNewOrder = async () => {
    try {
      const response = await axiosInstance.post(
        "/api/Order/createOrder",
        orderData
      );
      return response;
    } catch (error) {
      console.error("Error creating order:", error);
    }
  };

  const updateOrder = async () => {
    try {
      const response = await axiosInstance.post(
        "/api/Order/updateOrder",
        orderData
      );
      return response;
    } catch (error) {
      console.error("Error creating order:", error);
    }
  };

  const saveAndCreateOrder = async () => {
    const formErrors = await validateFields();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    } else {
      if (orderData.orderId > 0) {
        var response = await updateOrder();
        setSelectedDoctor(
          dentistList.filter((x) => x.dentistId === response?.dentistId)[0]
        );
      } else {
        var response = await createNewOrder();
        setSelectedDoctor(
          dentistList.filter((x) => x.dentistId === response?.dentistId)[0]
        );
      }
      navigate("/pick-up-and-order-creation");
    }
  };

  const getDueDate = async () => {
    try {
      const payload = [
        {
          departmentId: 1,
          departmentIndex: 0,
          hours: 8,
        },
      ];

      const response = await axiosInstance.post(
        "/api/order/getDueDeliveryDate",
        { AffectedDepartmentIds: payload }
      );
      return response?.data[0]?.dueDeliveryDate; // Assuming the response has a dueDate property
    } catch (error) {
      console.error("Error getting due date:", error);
      throw error;
    }
  };

  const validateFields = () => {
    const errors = {};
    if (orderData.dentistId == 0) {
      errors.dentistId = "Praxis Name erforderlich.";
    }
    // if (orderData.patientName == "") {
    //   errors.patientName = "Patienten Name erforderlich.";
    // }
    if (orderData.orderTypeId == 0) {
      errors.orderTypeId = "Bitte wähle eine Auftragsart.";
    }

    return errors;
  };

  return (
    <div className="">
      <style>
        {`
          #pre-order-sheet.hidden {
            display: none;
          }
        `}
      </style>
      <div
        className="relative rounded-[20px] bg-blue-400 mt-5 overflow-hidden
      before:content-[''] before:bottom-0 before:left-0 before:w-[240px] before:h-full before:bg-cover before:bg-left-bottom before:bg-no-repeat before:absolute before:bg-[url('./assets/images/round_border_bg_left.svg')] before:hidden lg:before:block
      after:content-[''] after:top-0 after:right-0 after:w-[308px] after:h-[470px] after:bg-cover after:bg-right-top after:bg-no-repeat after:absolute after:bg-[url('./assets/images/round_border_bg_right.svg')] after:hidden lg:after:block z-0
     "
        style={cardStyle}
      >
        <div className="bg-blue p-4 text-center rounded-t-[20px]">
          <h1 className="!text-xl sm:text-3xl xl:text-4xl 3xl:text-5xl text-white font-robotoBold leading-tight">
            Auftragsdetails
          </h1>
        </div>
        <div className="py-14 xl:py-10 3xl:py-14">
          <form className="2xl:w-7/12 lg:w-2/3 w-4/5 mx-auto z-10 relative">
            <div className="mb-5 font-inter relative">
              <label
                className="block text-gray-600 text-2xl xl:text-base 3xl:text-3xl font-medium mb-2"
                htmlFor="options"
              >
                Praxis
                <sup className="text-red">*</sup>
              </label>

              <Select
                className="appearance-none !border h-12 xl:h-10 3xl:h-12 !border-gray !leading-relaxed !text-2xl xl:!text-sm 3xl:!text-2xl bg-white !rounded-lg !w-full 2xl:min-w-[250px] !py-3 !px-5 xl:!py-2 xl:!px-3 3xl:!py-3 3xl:!px-5 text-gray-600 placeholder:!text-2xl xl:placeholder:!text-sm 3xl:placeholder:!text-2xl placeholder:!text-gray-400 hover:!border-blue-600 focus:!border-blue-600 focus:!outline-none !shadow-none"
                options={dentistList}
                labelField="dentistDisplayName"
                valueField="dentistDisplayName"
                values={dentistList.filter(
                  (dentist) => dentist.dentistId === orderData.dentistId
                )}
                defaultValue={orderData.dentistId}
                placeholder="Praxis"
                onChange={(selectedOptions) => {
                  if (selectedOptions[0]?.dentistId) {
                    const selectedDentistId = selectedOptions[0]?.dentistId;
                    setOrderData((prevState) => ({
                      ...prevState,
                      dentistId: selectedDentistId,
                    }));
                  }
                  setErrors((prevErrors) => {
                    const { dentistId, ...restErrors } = prevErrors;
                    return restErrors;
                  });
                }}
              />
              {/* Error message for dentistId */}
              {errors.dentistId && (
                <p className="text-red text-sm mt-1">{errors.dentistId}</p>
              )}
            </div>
            {/* <div className="mb-5 font-inter">
              <label
                className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl mb-2"
                htmlFor="id"
              >
                Patient
                <sup className="text-red">*</sup>
              </label>
              <input
                className="appearance-none border h-12 xl:h-10 3xl:h-12 !border-gray rounded-lg w-full !py-3 !px-5 xl:!py-2 xl:!px-3 3xl:!py-3 3xl:!px-5 text-gray-600 placeholder:!text-gray-400 hover:!border-blue-600 focus:!border-blue-600 focus:!outline-none focus:!shadow-outline"
                id="username"
                type="text"
                placeholder="Patient"
                value={orderData.patientName || ""}
                onChange={(event) => {
                  setOrderData((prevState) => ({
                    ...prevState,
                    patientName: event.target.value,
                  }));
                  setErrors((prevErrors) => {
                    const { patientName, ...restErrors } = prevErrors;
                    return restErrors;
                  });
                }}
              />
              {errors.patientName && (
                <p className="text-red text-sm mt-1">{errors.patientName}</p>
              )}
            </div> */}
            <div className="relative mb-5 font-inter">
              <FormControl>
                <label className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-medium mb-2">
                  Auftragsart
                  <sup className="text-red">*</sup>
                </label>
                {/* Error message for Delivery Date */}
                {errors.orderTypeId && (
                  <p className="text-red text-sm mt-1">{errors.orderTypeId}</p>
                )}
                <RadioGroup
                  defaultValue={orderData.orderTypeId?.toString()}
                  name="controlled-radio-buttons-group"
                  orientation="horizontal"
                  value={orderData.orderTypeId?.toString()}
                  className="gap-5 xl:gap-4 3xl:gap-5"
                  sx={{
                    gap: "20px",
                    flexWrap: "wrap",
                    margin: "0",
                    justifyContent: "space-between",
                    color: "gray-600 !important",
                  }}
                >
                  {orderTypeList.map((data, index) => (
                    <Radio
                      key={index}
                      className="!m-0 !text-gray-600 !font-interRegular text-2xl xl:!text-base 3xl:!text-2xl"
                      value={data.orderTypeId.toString()}
                      label={data.orderTypeName}
                      checked={orderData.orderTypeId === data.orderTypeId}
                      onClick={(event) => {
                        setOrderData((prevState) => ({
                          ...prevState,
                          orderTypeId: parseInt(event.target.value),
                        }));
                        setErrors((prevErrors) => {
                          const { orderTypeId, ...restErrors } = prevErrors;
                          return restErrors;
                        });
                      }}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </div>
          </form>
        </div>
      </div>
      <div className="3xl:py-10 align-center flex justify-end gap-5">
        {orderData?.orderId > 0 ? (
          <button
            className="px-5 py-2 text-2xl xl:!text-base 3xl:!text-2xl border uppercase border-blue-500 text-blue font-robotoBold rounded-lg hover:bg-blue-800 hover:border-blue-800 hover:text-white transition duration-300"
            onClick={() => {
              setOpenPopup(true);
            }}
          >
            Abbrechen
          </button>
        ) : (
          <button
            className="px-5 py-2 text-2xl xl:!text-base 3xl:!text-2xl border uppercase border-blue-500 text-blue font-robotoBold rounded-lg hover:bg-blue-800 hover:border-blue-800 hover:text-white transition duration-300"
            onClick={() => {
              navigate("/pick-up-and-order-creation");
            }}
          >
            Auftrag Löschen
          </button>
        )}

        <button
          onClick={saveAndCreateOrder}
          className="text-2xl xl:!text-base 3xl:!text-2xl bg-blue uppercase border border-blue hover:bg-blue-800 hover:border-blue-800 text-white font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in"
          type="button"
        >
          Speichern
        </button>
      </div>

      <DeleteOrderPopup
        openPopUp={openPopup}
        closePopUp={HandleDeletePopUp}
        orderId={orderData?.orderId}
      />

      <PreorderSheet
        pdfData={pdfData}
        formatDueDeliveryDate={formatDueDeliveryDate}
        isVisible={isVisible}
        selectedDoctor={selectedDoctor}
      />
    </div>
  );
};

export default AddDetailsForDelivery;
